import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { BrandLogo } from "@/components/BrandLogo";

export function SiteFooter({ logo, flyer, flyerDownload }) {
  return (
    <footer className="border-t border-slate-800 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid gap-8 md:grid-cols-4 text-sm">
        <div>
          <div className="flex items-center gap-2 mb-3">
            {logo ? <img src={logo} alt="Dr.Gadget" className="h-8 max-w-[160px] object-contain rounded-md" /> : <BrandLogo />}
          </div>
          <p className="text-slate-400">Tech support by phone and video, plus in-person installations in the Los Angeles area — A/V, security cameras, Wi-Fi, computers and gadgets. Homes and small business.</p>
          {flyer && (
            <a href={flyerDownload || flyer} download="Dr.Gadget-flyer.png" className="mt-4 flex items-center gap-3 group" data-testid="footer-flyer-link">
              <img src={flyer.includes("/api/media/") ? `${flyer}?w=480` : flyer} alt="Dr.Gadget flyer" loading="lazy" decoding="async" className="w-16 h-16 rounded-lg object-cover ring-1 ring-slate-700 group-hover:ring-cyan-400 transition-colors" data-testid="footer-flyer-thumb" />
              <span className="text-slate-300 group-hover:text-white flex items-center gap-1.5 transition-colors"><Download className="w-3.5 h-3.5 text-[#FFD600]" /> Save our flyer</span>
            </a>
          )}
        </div>
        <div>
          <div className="dg-eyebrow mb-3">Services</div>
          <ul className="space-y-2 text-slate-300">
            <li><Link to="/services" className="dg-link">30-Minute Session · $99.99</Link></li>
            <li><Link to="/services" className="dg-link">1-Hour Session · $149.99</Link></li>
            <li><Link to="/services" className="dg-link">1½-Hour Video Call · $249.99</Link></li>
            <li><Link to="/services" className="dg-link">A/V, CCTV, Wi-Fi & Business</Link></li>
          </ul>
        </div>
        <div>
          <div className="dg-eyebrow mb-3">Contact</div>
          <ul className="space-y-2 text-slate-300">
            <li><a href="tel:+13104220669" className="dg-link">310-422-0669</a></li>
            <li><a href="mailto:David@docdrgadget.com" className="dg-link" data-testid="footer-email-link">David@docdrgadget.com</a></li>
            <li>Phone · Zoom · FaceTime · Meet · Meeting app</li>
            <li>Mon–Sat · 8am–7pm</li>
          </ul>
        </div>
        <div>
          <div className="dg-eyebrow mb-3">Get help</div>
          <ul className="space-y-2 text-slate-300">
            <li><Link to="/services" className="dg-link">Pricing</Link></li>
            <li><Link to="/book" className="dg-link">Book a session</Link></li>
            <li><Link to="/book" className="dg-link">Before your call checklist</Link></li>
            <li><Link to="/ask" className="dg-link">Ask Dr.Gadget</Link></li>
            <li><Link to="/flyers" className="dg-link" data-testid="footer-flyers-link">Flyers to print & share</Link></li>
            <li><Link to="/gift" className="dg-link" data-testid="footer-gift-link">Gift a session</Link></li>
            <li><Link to="/review" className="dg-link" data-testid="footer-review-link">Leave a review</Link></li>
            <li><Link to="/membership" className="dg-link" data-testid="footer-membership-link">Dr.Gadget Care membership</Link></li>
            <li><Link to="/admin/login" className="dg-link">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 px-4 py-4 text-xs text-slate-500 text-center">
        © {new Date().getFullYear()} Dr.Gadget. All rights reserved.
      </div>
    </footer>
  );
}
